/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { Card } from 'primereact/card'
import { CalendarChangeParams } from 'primereact/calendar'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { ProgressSpinner } from 'primereact/progressspinner'
import { TabPanel, TabView, TabViewTabChangeParams } from 'primereact/tabview'
import { classNames } from 'primereact/utils'
import i18next from 'i18next'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

/* Styles - Assets */
import './Plan.scss'
import logo from '../../assets/images/koc-logo.svg'
import searchMarker from 'assets/icons/search-marker.svg'
import warning from '../../assets/icons/warning-icon.svg'

/*  Local Imports */
import HomeChart from '../../components/home/HomeChart'
import DatePickerIcon from '../../components/ui/DatePickerIcon'
import Button1 from '../../components/ui/Button1'
import BannerTab from '../../components/home/BannerTab'
import KvkkModal from '../../components/home/KvkkModal'
import ContractService from '../../service/ContractService'
import CampusService, { ICampusServiceExists } from 'service/CampusService'
import { IContract } from 'types/ContractType'
import { Occupancy, OccupancyFilterRequest, ReservationMeta } from '../../types/FloorType'
import { PlanTabs } from '../../types/PlanTabs'
import { IEmployeeSummary } from '../../types/Employee'
import ReservationService from '../../service/ReservationService'
import DateUtil from '../../utils/DateUtil'
import LocationService from '../../service/LocationService'
import { IMostUsedReservationResponse } from '../../types/Reservation'
import BlockService from '../../service/BlockService'
import FloorService from '../../service/FloorService'
import AuthUtil from '../../utils/AuthUtil'
import SharedOfficeService from '../../service/SharedOfficeService'
import { SharedOfficeRequest } from '../../types/SharedOffice'
import SharedOfficeModal from '../ui/modal/SharedOfficeModal'
import NotificationModal from '../../components/home/NotificationModal'
import NotificationModal2 from '../ui/modal/NotificationModal'
import { IRemoteOfficeType } from '../../types/MainType'
import HomeOfficeService from '../../service/HomeOfficeService'
import { ExemptionType } from '../../types/ExemptionType'
import OnCampusServices from './on-campus-services'
import useDidMountEffect from 'utils/useDidMountEffect'
import FavoritesList from './favorites-list'
import { getCurrentEmployee } from 'utils/Miscellaneous'

const Plan = (props: { notification: boolean }) => {
  const PILOT_FIRMS = !!process.env.REACT_APP_PILOT_FIRMS
    ? process.env.REACT_APP_PILOT_FIRMS.split(',').map((str) => Number(str))
    : []

  const IS_PILOT_USER = !!PILOT_FIRMS?.length ? PILOT_FIRMS.includes(getCurrentEmployee()?.firmId || 0) : true
  const { t } = useTranslation()
  const { search } = useLocation()
  const query = new URLSearchParams(search)
  const tabQuery = query.get('tab')

  const { notification } = props
  const history = useHistory()
  const [kvkkDisplay, setKvkkDisplay] = useState<boolean>(false)
  const [kvkkContent, setKvkkContent] = useState<IContract | undefined>()
  const [notificationDisplay, setNotificationDisplay] = useState<boolean>(false)
  const [form, setForm] = useState<ReservationMeta | undefined>()
  const [bannerDisabledButton, setBannerDisabledButton] = useState<boolean>(true)
  const [selectedFreDate, setSelectedFreDate] = useState<Date | Date[] | undefined>(DateUtil.getNearestWorkDay())
  const [minFreDate, setMinFreDate] = useState<Date | undefined>()
  const [maxFreDate, setMaxFreDate] = useState<Date | undefined>()
  const [employee, setEmployee] = useState<IEmployeeSummary | undefined>()
  const [mostUsedReservation, setMostUsedReservation] = useState<IMostUsedReservationResponse | undefined>()
  const [locationOccupancy, setLocationOccupancy] = useState<Occupancy | undefined>()
  const [blockOccupancy, setBlockOccupancy] = useState<Occupancy | undefined>()
  const [floorOccupancy, setFloorOccupancy] = useState<Occupancy | undefined>()
  const [planTabs, setPlanTabs] = useState<PlanTabs[]>([])
  const [hasCampusPlan, setHasCampusPlan] = useState<boolean>(false)
  const [activeTab, setActiveTab] = useState<number>(0)
  const [isShowMessage, setIsShowMessage] = useState<boolean>()
  const [dayList, setDayList] = useState<string[] | undefined>()
  const [messageTr, setMessageTr] = useState<string>()
  const [floorCalendarVisible, setFloorCalendarVisible] = useState<boolean>(false)
  const [floorCalendarMessage, setFloorCalendarMessage] = useState<string>()
  const [visible, setVisible] = useState(false)
  const [floorDayList, setFloorDayList] = useState<string[] | undefined>()
  const [, setFloorShowMessage] = useState<boolean>()
  const [types, setTypes] = useState<IRemoteOfficeType[]>([])
  const [selectedType, setSelectedType] = useState<any>()
  const [isAbroad, setIsAbroad] = useState({ name: 'countries.turkey', isAbroad: false })
  const [visibilityMostUsedButton, setVisibilityMostUsedButton] = useState<boolean>(true)
  const [notificationVisible, setNotificationVisible] = useState<boolean>(notification)
  const [campusVisible, setCampusVisible] = useState<ICampusServiceExists | undefined>()
  const [loading, setLoading] = useState(false)

  /* Remote Type options first type => remote(uzaktan) */
  const setRemoteTypeFirst = () => {
    HomeOfficeService.getRemoteOfficeTypeList().then((resp: any) => {
      let officeTypes = resp.data || []
      const firstType = officeTypes?.find((t: IRemoteOfficeType) => t.id === 0)
      officeTypes = officeTypes?.filter((item: IRemoteOfficeType) => item.id !== 0)
      officeTypes?.unshift(firstType)
      setTypes(officeTypes)
      if (resp.data.length > 0) setSelectedType(officeTypes[0])
    })
  }

  useEffect(() => {
    setRemoteTypeFirst()

    setLoading(true)
    CampusService.getCampusServiceExists()
      .then((r) => setCampusVisible(r.data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))

    let employeeSummary = AuthUtil.getEmployeeSummary()
    if (employeeSummary !== null) {
      setEmployee(employeeSummary)
      setPlanTabs(AuthUtil.getPlanTabsAuthorized(employeeSummary.exemptionSpecList))
      setHasCampusPlan(AuthUtil.hasCampus(employeeSummary.exemptionSpecList))
    }
  }, [])

  useEffect(() => {
    if (typeof employee !== 'undefined') {
      getEmployeeSummary()
      getMostUsedReservation()
      setCalendarReach()
    }
  }, [employee])

  useEffect(() => {
    if (
      activeTab === planTabs.indexOf(PlanTabs.AWAY) &&
      (employee?.pastOrientedDayCount !== 0 || employee?.futureOrientedDayCount !== 0)
    )
      setBannerDisabledButton(false)
  }, [form, activeTab])

  useEffect(() => {
    if (mostUsedReservation !== undefined) getMostUsedReservationService(getNearestDateAsString())
  }, [mostUsedReservation])

  function getNearestDateAsString(): string {
    let mostCloseWorkDay = DateUtil.getNearestWorkDay()
    return DateUtil.formatDateToString(mostCloseWorkDay)
  }

  const getSharedCheckAvaible = async () => {
    form?.startDate.setHours(0, 0, 0, 0)
    form?.endDate.setHours(0, 0, 0, 0)
    let request: SharedOfficeRequest = {
      floorId: form?.selectedFloor?._id,
      startDate: DateUtil.formatDateToString(form?.startDate!),
      endDate: DateUtil.formatDateToString(form?.endDate!),
    }

    await SharedOfficeService.getCheckFloorIsAvailable(request)
      .then((response) => {
        FloorService.getFloorCalendarDaysAvailable(request).then((floorResponse) => {
          if (floorResponse.data.showMessage || response.data.showMessage) {
            if (!floorResponse.data.showMessage && response.data.showMessage) {
              setIsShowMessage(true)
              setMessageTr(
                i18next.language === 'en' ? response.data.responseMessageEN : response.data.responseMessageTR
              )
              setVisible(true)
              setDayList(response.data?.dayList)
            } else if (floorResponse.data.showMessage && !response.data.showMessage) {
              setFloorShowMessage(true)
              setFloorCalendarMessage(
                i18next.language === 'en' ? floorResponse.data.responseMessageEN : floorResponse.data.responseMessageTR
              )
              setFloorCalendarVisible(true)
              setFloorDayList(floorResponse.data?.dayList)
            } else {
              setIsShowMessage(true)
              setMessageTr(
                i18next.language === 'en' ? response.data.responseMessageEN : response.data.responseMessageTR
              )
              setVisible(true)
              setDayList(response.data?.dayList)
            }
          } else {
            history.push({ pathname: '/reservation', state: { response: form } })
          }
        })
      })
      .catch((e) => {
        console.log('error', e)
      })
  }

  const getMostUsedReservation = () => {
    ReservationService.getMostUsedReservation(getNearestDateAsString())
      .then((response) => {
        setMostUsedReservation({
          ...response.data,
          _id: response.data.floorId,
          _floorName: response.data.floorName,
          _fullLocation: [
            response.data?.locationName,
            response.data?.districtName,
            response.data?.blockName,
            response.data?.floorName,
          ]
            .filter((val) => val)
            .join(', '),
        })
      })
      .catch((e) => console.log(e))
  }

  const setCalendarReach = () => {
    let employee = AuthUtil.getEmployeeSummary() as IEmployeeSummary
    let date = new Date()
    let futureDate = new Date()
    let pastDate = new Date()

    let futureDayCount = Number(employee.futureOrientedDayCount)
    let pastDayCount = Number(employee.pastOrientedDayCount)

    futureDate.setDate(futureDate.getDate() + futureDayCount)
    setMaxFreDate(futureDate)

    pastDate.setDate(pastDate.getDate() - pastDayCount)
    setMinFreDate(pastDate)

    if (pastDayCount !== 0) {
      let dayOfWeek = date.getDay()
      if (dayOfWeek === 6) {
        date.setDate(date.getDate() + 2)
      } else if (dayOfWeek === 0) {
        date.setDate(date.getDate() + 1)
      }
      date.setHours(0, 0, 0, 0)
      setSelectedFreDate(date)
    } else {
      date.setDate(date.getDate() + 1)
      let dayOfWeek = date.getDay()
      if (dayOfWeek === 6) {
        date.setDate(date.getDate() + 2)
      } else if (dayOfWeek === 0) {
        date.setDate(date.getDate() + 1)
      }
      date.setHours(0, 0, 0, 0)
      setSelectedFreDate(date)
      setMinFreDate(date)
    }
  }

  const getMostUsedReservationService = (date: string) => {
    var exemptionType = mostUsedReservation?.isSharedOffice ? ExemptionType.COMMON : ExemptionType.OFFICE
    var exemptionExists =
      employee?.exemptionSpecList === undefined
        ? []
        : employee?.exemptionSpecList.filter((e: any) => e.Code === exemptionType)
    if (exemptionExists.length <= 0) setVisibilityMostUsedButton(true)
    else setVisibilityMostUsedButton(false)
    getLocationOccupancy(date)
    getBlockOccupancy(date)
    getFloorOccupancy(date)
    setForm((prevForm: any) => {
      return {
        isNew: true,
        startDate: prevForm?.startDate!,
        endDate: prevForm?.endDate!,
        selectedFloor: mostUsedReservation!,
        isAbroad: prevForm?.isAbroad,
      }
    })
  }

  const getLocationOccupancy = (date: string) => {
    let req: OccupancyFilterRequest = { id: mostUsedReservation?.locationId as number, occupancyDate: date }
    LocationService.GetLocationOccupancy(req)
      .then((response) => {
        setLocationOccupancy(response.data)
      })
      .catch((e) => console.log(e))
  }

  const getBlockOccupancy = (date: string) => {
    let req: OccupancyFilterRequest = { id: mostUsedReservation?.blockId as number, occupancyDate: date }
    BlockService.GetBlockOccupancy(req)
      .then((response) => {
        setBlockOccupancy(response.data)
      })
      .catch((e) => console.log(e))
  }

  const getFloorOccupancy = (date: string) => {
    let req: OccupancyFilterRequest = { id: mostUsedReservation?.floorId as number, occupancyDate: date }
    FloorService.GetFloorOccupancy(req)
      .then((response) => {
        setFloorOccupancy(response.data)
      })
      .catch((e) => console.log(e))
  }

  const getEmployeeSummary = () => {
    const kvkkShow = localStorage.getItem('kvkkDisplay')
    const hasPendingContract = (employee as IEmployeeSummary).hasPendingContract
    if (kvkkShow === 'false' && hasPendingContract) getPendingContractList()
    else return
  }

  const getPendingContractList = () => {
    ContractService.getPendingContractList()
      .then((response) => {
        setKvkkContent(response.data[0])
        setKvkkDisplay(true)
      })
      .then(() => localStorage.setItem('kvkkDisplay', 'true'))
      .catch((e) => console.log(e))
  }

  const submit = async () => {
    const pastDateCount = Number(employee?.pastOrientedDayCount)
    const nowDate = moment(new Date())
    const dateDifference = nowDate.diff(moment(form?.startDate), 'days')
    if (dateDifference <= pastDateCount) {
      if (activeTab === planTabs.indexOf(PlanTabs.AWAY)) {
        setNotificationDisplay(true)
      } else {
        if (form?.selectedFloor !== undefined && form?.startDate !== undefined) {
          await getSharedCheckAvaible()
        }
      }
    }
  }

  useEffect(() => {
    setForm({
      isNew: true,
      startDate: selectedFreDate as Date,
      endDate: selectedFreDate as Date,
      selectedFloor: mostUsedReservation!,
      planTab: mostUsedReservation?.isSharedOffice ? PlanTabs.COMMON : PlanTabs.OFFICE,
      isAbroad: isAbroad,
    })
  }, [selectedFreDate])

  function submitForFrequently() {
    setForm({
      isNew: true,
      startDate: selectedFreDate as Date,
      endDate: selectedFreDate as Date,
      selectedFloor: mostUsedReservation!,
      planTab: mostUsedReservation?.isSharedOffice ? PlanTabs.COMMON : PlanTabs.OFFICE,
      isAbroad: isAbroad,
    })
    getSharedCheckAvaible()
  }

  function changeFormForFrequently(e: CalendarChangeParams) {
    setSelectedFreDate(e.value as Date)
  }

  function setBannerForm(meta: ReservationMeta | undefined) {
    if (employee?.pastOrientedDayCount === 0 && employee?.futureOrientedDayCount === 0) {
      setBannerDisabledButton(true)
    } else {
      setForm(meta)
      if (meta?.selectedFloor !== undefined && typeof meta?.selectedFloor === 'object') setBannerDisabledButton(false)
      else setBannerDisabledButton(true)
    }
  }
  const plansHeader = [
    { key: 'Uzaktan Çalışma', value: 'remote-work' },
    { key: 'Şirketimin Ofisleri', value: 'company-work' },
    { key: 'Ortak Ofisler', value: 'shared-office' },
  ]

  /* Park Area Redirect Control */
  useEffect(() => {
    if (!!tabQuery && tabQuery === 'park') setActiveTab(3)
  }, [])

  const [, setKeys] = useState(1)
  const handleTabChange = (e: TabViewTabChangeParams) => {
    if (!!tabQuery) history.replace('/home')
    setActiveTab(e.index)
    setKeys((prev) => prev + 1)
  }

  /* Variables - states */
  const hasNoPlan = planTabs.length === 0 && !hasCampusPlan
  const isOnCampusService = !planTabs[activeTab]
  const isRemoteWork = activeTab === planTabs.indexOf(PlanTabs.AWAY)
  useDidMountEffect(() => planTabs?.length === 0 && setActiveTab(1), [planTabs])

  /* Loading state */
  if (loading || (!kvkkContent && !mostUsedReservation && !locationOccupancy && !blockOccupancy && !floorOccupancy)) {
    return (
      <KVKKWrapper className={'loading'}>
        <ProgressSpinner style={{ position: 'absolute', width: '120px', zIndex: 1102 }} />
        <img alt="Yükleniyor..." style={{ position: 'absolute', width: '60px', zIndex: 1102 }} src={logo} />
      </KVKKWrapper>
    )
  }

  const shouldRenderComponent =
    !!campusVisible &&
    campusVisible?.isAnyExist &&
    (hasCampusPlan ||
      campusVisible?.isParkAreaServiceExist ||
      campusVisible?.isMeetingServiceExist ||
      campusVisible?.isPoolVehicleServiceExist)

  return (
    <>
      <div className="banner">
        <div className="banner-img" />
        <div className={classNames(isOnCampusService ? 'banner-top-extended' : 'banner-top')}>
          <div className="container">
            <div className="banner-summary">
              <div className="row me-0">
                <p className="banner-title">{`${t('homepage.hello')} ${employee?.name}`}</p>
                <p className="banner-text">{t('homepage.welcome-text')}</p>
              </div>
            </div>

            {/* Tab Items */}
            <Card className={classNames(hasNoPlan ? 'banner-form-empty' : 'banner-form')}>
              {!hasNoPlan ? (
                <div className="banner-header">
                  <TabView renderActiveOnly activeIndex={activeTab} onTabChange={handleTabChange}>
                    {planTabs.length !== 0 &&
                      planTabs.map((plan) => {
                        return (
                          <TabPanel
                            key={plan}
                            header={t(`tabs.${plansHeader.find((item) => item.key === plan)?.value}`)}>
                            <BannerTab
                              isAbroad={isAbroad}
                              setIsAbroad={setIsAbroad}
                              isReservationSearch={false}
                              form={form}
                              setDisabled={setBannerDisabledButton}
                              onChangeForm={(meta) => setBannerForm(meta)}
                              name={plan}
                              selectedStartDate={new Date()}
                              selectedType={selectedType}
                              setSelectedType={setSelectedType}
                              types={types}
                              selectedEndDate={new Date()}
                              employee={employee}
                              selectStyle="col-lg-7 col-12 mb-2"
                              dateStyle="col-lg-5 col-12"
                            />

                            <div className="banner-body d-flex justify-content-center align-items-center">
                              <div className={classNames(isRemoteWork ? 'col-lg-6 ' : 'col-lg-4', 'pe-lg-4')}>
                                <Button1
                                  class={'button-blue'}
                                  label={isRemoteWork ? t('buttons.remote-notify') : t('buttons.search-office')}
                                  onClick={submit}
                                  disabled={bannerDisabledButton}
                                />
                              </div>

                              {!isRemoteWork ? (
                                <div className="d-flex gap-2 align-items-center">
                                  <img src={searchMarker} alt="map-search" />
                                  <StyledLink to={{ pathname: '/map', state: { response: form } }}>
                                    {t('buttons.search-map')}
                                  </StyledLink>
                                </div>
                              ) : null}
                            </div>
                          </TabPanel>
                        )
                      })}

                    {/* On Campus Services */}
                    {shouldRenderComponent ? (
                      <TabPanel header={t('tabs.on-campus-services')}>
                        <OnCampusServices campusVisible={campusVisible} redirectCommon={setActiveTab} />
                      </TabPanel>
                    ) : null}
                  </TabView>
                </div>
              ) : (
                <div className="w-100 h-100 d-flex flex-column gap-3 justify-content-center align-items-center">
                  <img src={warning} width={85} height={85} alt="no-reservation" />
                  <span className="fw-semibold">{t('homepage.no-plan-tabs')}</span>
                </div>
              )}
            </Card>
          </div>
        </div>

        {/* Frequently Work Locations */}
        {!hasNoPlan && (
          <div className="container">
            {IS_PILOT_USER && AuthUtil.isAdmin(employee?.authList) && (
              <FavoritesList planTabs={planTabs} campusVisible={campusVisible} hasCampusPlan={hasCampusPlan} />
            )}

            <div className="frequent">
              <div className="row me-0 ms-0 mb-2">
                <span className="fre-title ">{t('homepage.most-work-location')}</span>
              </div>
              <div className="row me-0 ms-0 frequented-places">
                <div className="row me-0 mb-4">
                  <div className="col-12">
                    {mostUsedReservation?.locationName !== null ? (
                      <span className="fre-location">{[
                        mostUsedReservation?.locationName,
                        mostUsedReservation?.locationFirmName,
                        mostUsedReservation?.districtName,
                        mostUsedReservation?.cityName,
                        mostUsedReservation?.countryName
                      ].filter(val => val).join(', ')}</span>
                    ) : null}
                  </div>
                </div>
                <div className="row me-0 ">
                  <div className="col-lg-7">
                    <div className="row me-0">
                      <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                        <HomeChart
                          labelText={t('most-used-words.location')}
                          knobValue={locationOccupancy?.percentage}
                          name={locationOccupancy?.name}
                        />
                      </div>
                      <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                        <HomeChart
                          labelText={t('most-used-words.block')}
                          knobValue={blockOccupancy?.percentage}
                          name={blockOccupancy?.name}
                        />
                      </div>
                      <div className="col-xl-4 col-lg-6 col-12">
                        <HomeChart
                          labelText={t('most-used-words.floor')}
                          knobValue={floorOccupancy?.percentage}
                          name={floorOccupancy?.name}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="row me-0 ms-0">
                      <div className="col-12 mb-3">
                        <span>{t('homepage.question-of-homepage')}</span>
                      </div>
                      <div className="col-12 mb-3">
                        <DatePickerIcon
                          idName={'plans'}
                          defaultDate={selectedFreDate}
                          minDate={minFreDate}
                          maxDate={maxFreDate}
                          label={t('input-texts.date')}
                          onSelectedDateChange={(e: CalendarChangeParams) => {
                            changeFormForFrequently(e)
                          }}
                        />
                      </div>
                      <div className="col-12 mb-3" style={{ display: visibilityMostUsedButton ? 'block' : 'none' }}>
                        <Button1
                          class={'button-blue'}
                          label={t('buttons.go-to-office')}
                          onClick={(e) => submitForFrequently()}
                          disabled={mostUsedReservation === undefined || mostUsedReservation.locationName === null}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {notificationVisible && (
        <NotificationModal2
          isManager={employee?.isManager!}
          setVisible={() => setNotificationVisible(false)}
          visible={notificationVisible}
          close={() => setNotificationVisible(false)}
        />
      )}

      <KvkkModal
        display={kvkkDisplay}
        onHide={() => setKvkkDisplay(false)}
        onSubmit={(e) => setKvkkDisplay(false)}
        content={kvkkContent}
      />

      {notificationDisplay && form?.startDate !== undefined && form?.endDate !== undefined ? (
        <NotificationModal
          selectedType={selectedType}
          types={types}
          display={notificationDisplay}
          onHide={() => setNotificationDisplay(false)}
          onSubmit={(e) => setNotificationDisplay(false)}
          isSuccess={false}
          meta={form}
        />
      ) : null}

      {isShowMessage && (
        <SharedOfficeModal visible={visible} setVisible={setVisible} messageTr={messageTr} dayList={dayList} />
      )}

      {floorCalendarVisible && (
        <SharedOfficeModal
          visible={floorCalendarVisible}
          setVisible={setFloorCalendarVisible}
          messageTr={floorCalendarMessage}
          dayList={floorDayList}
        />
      )}
    </>
  )
}

export default Plan

const KVKKWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  z-index: 1102;
`

const StyledLink = styled(Link)`
  color: #45bfe5;
  font-size: 16px;
  letter-spacing: 0.02rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  &:hover {
    color: #1388e5;
  }
`
